import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

/**
 * LA PHOTO DE LA PERSONNE, OU SES INITIALES A DEFAUT — contenu d'un rond d'avatar des ecrans d'appel.
 *
 * Le rond (taille, fond, bordure) reste a l'ecran qui l'emploie, avec `overflow-hidden` : ce composant ne
 * dessine que son contenu. Pas de photo, ou photo qui ne charge pas (lien mort, hors ligne) : les initiales
 * s'affichent, jamais une image cassee.
 */
@Component({
  selector: 'app-photo-appel',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
  template: `
    @if (photo() && !echec()) {
      <img [src]="photo()" [alt]="nom()" class="w-full h-full object-cover" (error)="echec.set(true)" draggable="false" />
    } @else {
      {{ initiales() }}
    }
  `,
})
export class PhotoAppelComponent {
  /** URL de la photo de profil, quand la personne en a une. */
  readonly photo = input<string | null | undefined>();
  /** Nom de la personne : le texte alternatif de la photo. */
  readonly nom = input.required<string>();
  /** Ce qu'on affiche sans photo. */
  readonly initiales = input.required<string>();

  /** Vrai quand l'image n'a pas pu etre chargee : on retombe sur les initiales. */
  protected readonly echec = signal(false);
}
